import {observer} from 'mobx-react';
import {AlertModal, ModalDangerButtons} from 'shared/components/modals';

const DeletePromptModal = observer(({isOpen, uiState}) => {
  return (
    <AlertModal
      mode='danger'
      size='sm'
      header='recruiting.hiring_funnel.Delete Prompt'
      subHeader='recruiting.hiring_funnel.Are you sure you want to delete this prompt?'
      body='recruiting.hiring_funnel.This prompt and all the associated candidate ratings will be deleted.'
      onHide={() => uiState.closeDeletePromptModal()}
      isOpen={isOpen}
    >
      <ModalDangerButtons
        saveCaption={'Delete'}
        onCancel={() => uiState.closeDeletePromptModal()}
        onSave={() => uiState.deletePrompt()}
      />
    </AlertModal>
  );
});

export default DeletePromptModal;
